import { axiosClient } from '@services/clients'

export async function getUserTransactions(
  playerId,
  dateStart,
  dateEnd,
  wallet,
  transactionType,
  itemsCount,
  page,
  search,
) {
  const { data } = await axiosClient(
    `/transactions/player/${playerId}?start=${dateStart}&end=${dateEnd}&wallet=${wallet}&type=${transactionType}&limit=${itemsCount}&page=${page}&text=${search}`,
  )
  return data
}

export async function getTransactions(
  dateStart,
  dateEnd,
  currency,
  transactionType,
  showPage,
  page,
) {
  const { data } = await axiosClient(
    `/transactions?start=${dateStart}&end=${dateEnd}&currency=${currency}&type=${transactionType}&limit=${showPage}&page=${page}`,
  )
  return data
}

export async function getTransactionsTypes() {
  const {
    data: { result },
  } = await axiosClient('/transactions/types')

  return result
}

export async function getTopPlayers(date, players) {
  const {
    data: { result },
  } = await axiosClient(`/transactions/top/?limit=${players}&days=${date}`)
  return result
}

export async function postBonusTransaction(data) {
  const result = await axiosClient.post('/transactions', data)

  if (result.status === 201) {
    return {
      ...result.data,
      ...data,
    }
  }

  throw new Error(result?.response?.data?.error?.description)
}

export async function postBulkManualTransactions({ transactions, category }) {
  const {
    data: { result },
  } = await axiosClient.post('/bulk-transactions', transactions, {
    // PHOENIX-520: the category applies to the whole upload and is sent as a
    // query parameter so the CSV-derived body (player_id + amount rows) is
    // unchanged. Omitted entirely when no category is selected.
    params: category ? { category } : undefined,
  })
  return result
}

// PHOENIX-520: fetch the active adjustment categories that feed the operator
// category dropdown. When the BALANCE_ADJUSTMENT_CATEGORY feature flag is off
// the backend returns an empty array, so no dropdown renders (implicit FF gate).
export async function getAdjustmentCategories() {
  const {
    data: { result },
  } = await axiosClient('/adjustment-categories')
  return result
}
